import { Download } from '@mui/icons-material';
import { Box, Typography } from '@mui/material';
import { useLocalTranslation } from '../../../../utils/i18nKit';
import { openUrlWithNewWindow } from '../../../../utils/url';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

var IntroResourceRow = function IntroResourceRow(props) {
  var item = props.item;

  var _useLocalTranslation = useLocalTranslation(),
      $t = _useLocalTranslation.$t;
  /**
   * methods
   */


  var downloadAction = function downloadAction() {
    if (!item.url || item.url === '#') return;
    openUrlWithNewWindow(item.url);
  };

  return /*#__PURE__*/_jsxs(Box, {
    className: "grid grid-cols-[1fr_auto] items-center gap-x-4 rounded-xl bg-white px-6 py-5 md:grid-cols-[1fr_120px] md:px-8",
    children: [/*#__PURE__*/_jsx(Typography, {
      className: "text-sm font-bold text-[#202020] md:text-base",
      children: item.title
    }), /*#__PURE__*/_jsx(Box, {
      className: "flex md:justify-center",
      children: /*#__PURE__*/_jsx(Box, {
        component: "span",
        className: "cursor-pointer text-[#006DB0] transition-opacity hover:opacity-70",
        onClick: downloadAction,
        title: $t('page:subBrokerPortal.download_document', {
          title: item.title
        }),
        children: /*#__PURE__*/_jsx(Download, {
          className: "h-7 w-7"
        })
      })
    })]
  });
};

export default IntroResourceRow;